import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import '../ProjectPages/ProjectPage.css';

// Import images
import webHeroImage from '../../assets/images/web.jpg';

const CorporateWebEN = () => {
  return (
    <div className="project-page">
      <Helmet>
        <title>Corporate Web Solutions | Professional Website and E-Commerce - ProgenX 2025</title>
        <meta name="description" content="ProgenX corporate web solutions. Modern and impressive websites, e-commerce systems, digital marketing support. Be your business's digital face. SEO-compliant, fast, and reliable web solutions." />
        <meta name="keywords" content="corporate website, e-commerce solutions, digital marketing, web design, corporate identity, seo compliant website, responsive web design, turkey web design company" />
        <meta property="og:title" content="Corporate Web Solutions | ProgenX" />
        <meta property="og:description" content="Create a strong presence in the digital world with professional websites and e-commerce solutions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/en/projects/corporate-web-solutions" />
        <link rel="canonical" href="https://progenxacademy.com/en/projects/corporate-web-solutions" />
        <link rel="alternate" hreflang="tr" href="https://progenxacademy.com/projeler/kurumsal-web-cozumleri" />
        <link rel="alternate" hreflang="en" href="https://progenxacademy.com/en/projects/corporate-web-solutions" />
      </Helmet>

      <Hero 
        title="Corporate Web Solutions" 
        backgroundImage={webHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>Your Business's Digital Face</h2>
            <p>
              Your website is your business's face in the digital world. Your customers see you there first, 
              form their first impression there. As ProgenX, we develop websites that best reflect your business's 
              corporate identity, impress your customers, and provide them with easy access.
            </p>
          </section>

          <section className="project-features">
            <h3>What Types of Web Solutions Do We Offer?</h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>Corporate Websites</h4>
                <p>
                  Professional websites that tell your business's story and showcase your products and services. 
                  Phone, tablet, computer - looks perfect on every device. Ranks high on Google, you can easily update your content.
                </p>
              </div>

              <div className="feature-item">
                <h4>E-Commerce Sites</h4>
                <p>
                  E-commerce sites that allow you to sell your products online. Secure payment 
                  systems, inventory tracking, order management - everything in one place. 
                  Your customers shop easily, you manage easily.
                </p>
              </div>

              <div className="feature-item">
                <h4>Digital Marketing Support</h4>
                <p>
                  After your website is ready, we help you reach your customers. 
                  We ensure you rank high on Google, increase your visibility on social media, 
                  and support you in gaining customers.
                </p>
              </div>

              <div className="feature-item">
                <h4>Custom Solutions for Your Business</h4>
                <p>
                  Solutions that work integrated with your existing systems, developed according to your business's special needs. 
                  Your customer management systems, inventory tracking systems 
                  - all work compatible with your website.
                </p>
              </div>
            </div>
          </section>

          <section className="project-benefits">
            <h3>What Do We Provide for Your Business?</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h4>Professional and Impressive Appearance</h4>
                <p>Your website reflects your business's corporate identity, impresses your customers. 
                Strengthens your brand with modern and elegant designs.</p>
              </div>
              <div className="benefit-item">
                <h4>Fast and Reliable</h4>
                <p>Your website loads quickly and works securely. Your customers easily 
                access and share information safely.</p>
              </div>
              <div className="benefit-item">
                <h4>More Customers</h4>
                <p>You rank high on Google and become visible on social media. 
                More customers visit your website and contact you.</p>
              </div>
              <div className="benefit-item">
                <h4>Always Up to Date</h4>
                <p>You can easily update your website and manage your content. 
                As your needs change, your website also evolves.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Be a Strong Presence in the Digital World"
        subtitle="Reach your customers with your professional website and grow your business."
        buttonText="Get Quote" 
        buttonLink="/en/contact" 
      />
    </div>
  );
};

export default CorporateWebEN;
